import { router, useFocusEffect } from "expo-router";
import { useCallback } from "react";
import { View } from "react-native";

/**
 * Catch-all for unknown paths inside the student portal. Anything that
 * doesn\'t match a real student route bounces back to the dashboard so
 * users can\'t accidentally (or deliberately) land on stale UI.
 */
export default function StudentNotFoundRedirect() {
  useFocusEffect(
    useCallback(() => {
      router.replace("/student");
    }, [])
  );
  return <View />;
}
